var map = {
	"./ar/about.json": 8228,
	"./ar/common.json": 8634,
	"./ar/contact.json": 3301,
	"./ar/details.json": 8167,
	"./ar/footer.json": 6828,
	"./ar/header.json": 5306,
	"./ar/home.json": 164,
	"./ar/info.json": 2851,
	"./ar/videos.json": 1763,
	"./en/about.json": 9732,
	"./en/common.json": 9802,
	"./en/contact.json": 5189,
	"./en/details.json": 2855,
	"./en/footer.json": 8172,
	"./en/header.json": 1514,
	"./en/home.json": 4820,
	"./en/info.json": 2099,
	"./en/videos.json": 9795,
	"./tr/about.json": 7829,
	"./tr/common.json": 9409,
	"./tr/contact.json": 408,
	"./tr/details.json": 7334,
	"./tr/footer.json": 5783,
	"./tr/header.json": 3525,
	"./tr/home.json": 5091,
	"./tr/info.json": 2040,
	"./tr/videos.json": 5684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3901;